const dialog = document.getElementById('workDialog');
const dialogContent = document.getElementById('dialogContent');
const closeButton = document.querySelector("dialog button");

if (dialog) {
    document.addEventListener('click', (e) => {
        const button = e.target.closest('#dialogBtn, .open-modal');

        if (button) {
            e.preventDefault();
            e.stopPropagation();
            const itemData = button.dataset.item;
            if (itemData) {
                dialogContent.innerHTML = `<div class="modal-body">${itemData || ''}</div>`;
                dialog.showModal();
            }
        }
    });

    closeButton.addEventListener("click", () => {
        dialog.close();
    });
}